import React from "react";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
// import Banner1 from "../assets/Crusie_Deal_Banner_Final_genting.webp";
// import Banner2 from "../assets/Crusie_Deal_Banner_Final_royal.webp";
// import Banner3 from "../assets/Crusie_Deal_Banner_Final_Disney.webp"
import ScrolltoTop from "../components/ScrolltoTop";
import HeroBanner from "../components/HeroBanner";
import CruiseLines from "../components/CruiseLines";
import '../singapore.css' ;
import Itineraries from "../components/Itineraries";
import LandCruisePackages from "../components/LandCruisePackages";
// import FlyCruisePackages from "../components/FlyCruisePackages";
import WhatsIncluded from "../components/WhatsIncluded";
import VisaInfo from "../components/VisaInfo";
// import AutoSingaporeForm from "../components/ui/AutoSingaporeForm";
import UTMHandler from "../components/UTMHandler";
import AutoShowModal from "../components/AutoShowModal";


const Singapore =()=> {
    return(
        <>
        <UTMHandler/>
        
        <div className="about-navbar">
        <Navbar/>
        </div>
 
       <HeroBanner/>
       <CruiseLines/>
       <Itineraries/>
       <LandCruisePackages/>
       {/* <FlyCruisePackages/> */}
       <WhatsIncluded/>
       <VisaInfo/>

       
        {/* <div className="Singapore-offer-banner">

         <div>
          <img src={Banner1} alt="Singapore cruise banner -int2cruises"></img>
         </div>   
         <div>
            <a href="https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&ship=13717&sortcolumn=cruiselinePriority&sortorder=asc&_gl=1*1pr70mh*_gcl_au*OTY1NjU2ODU5LjE3NDE3NjYxNTE.*_ga*MTUwNjA1MTY0MS4xNzQxNzY2MTUy*_ga_J63THWN7N4*czE3NDc5MTA3MjUkbzI4JGcxJHQxNzQ3OTE2MjY3JGowJGwwJGgw*_ga_QKJVB4ZJQG*czE3NDc5MDYzOTUkbzU0JGcxJHQxNzQ3OTE2MzAxJGowJGwwJGgw" target="_self">
            <img src={Banner2} alt="Singapore cruise banner -int2cruises"></img> 
            </a>
        </div>   
         <div>
            <a href="https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&ship=15406&sortcolumn=cruiselinePriority&sortorder=asc&_gl=1*lk5tiq*_gcl_au*OTY1NjU2ODU5LjE3NDE3NjYxNTE.*_ga*MTUwNjA1MTY0MS4xNzQxNzY2MTUy*_ga_QKJVB4ZJQG*czE3NDc5MDYzOTUkbzU0JGcxJHQxNzQ3OTE2NDA2JGowJGwwJGgw*_ga_J63THWN7N4*czE3NDc5MTA3MjUkbzI4JGcxJHQxNzQ3OTE2NDA2JGowJGwwJGgw" target="_self">
            <img src={Banner3} alt="Singapore cruise banner -int2cruises"></img>
            </a>
        </div>   

        </div> */}

     <ScrolltoTop/>

     <AutoShowModal/>
     {/* <AutoSingaporeForm/> */}
    
        <Footer/>
        </>
    );
}

export default Singapore ;